export const DELETE_USER = "DELETE_USER";

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";

export const UPDATE_PROFILE = "UPDATE_PROFILE";